// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35oEB","left":"styles_left__2h_GH","desktopActions":"styles_desktopActions__2dd1S","title":"styles_title__3B8MD"};